import posthog from "posthog-js";
import { getStoredSessionId } from "@/services/auth.service";

export function registerSession() {
  const sessionId = getStoredSessionId();
  if (sessionId) posthog.register({ session_id: sessionId });
}

export function unregisterSession() {
  posthog.unregister("session_id");
}

/** Capture an exception to PostHog. No-op in development. */
export function captureError(error: unknown, additionalProperties: Record<string, unknown> = {}): void {
  if (import.meta.env.MODE === 'development') return;
  posthog.captureException(error, additionalProperties);
}

export default posthog;
